import API from "@unisearch/helpers/api";
import { BestCountry, BlogUpdate, StudyArea } from "@modules/study/home";
import BannerTwo from "@modules/study/home/banner";
import { LayoutMain } from "@unisearch/theme/layout";

const Student = (props) => {
  const { allCountry, allSpecialization, posts } = props;

  return (
    <LayoutMain
      title="Welcome to Uni Search"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/student`}
    >
      <BannerTwo />
      {allSpecialization?.length > 0 && (
        <StudyArea allSpecialization={allSpecialization} />
      )}
      {allCountry?.length > 0 && <BestCountry allCountry={allCountry} />}
      {posts?.length > 0 && <BlogUpdate posts={posts} />}
    </LayoutMain>
  );
};

export default Student;

export async function getServerSideProps() {
  let props = {
    allCountry: "",
    allSpecialization: "",
    posts: "",
  };

  try {
    await API.get(`/public/country/workable-total`).then((resp) => {
      if (!resp.error && resp.data) {
        props.allCountry = resp.data;
      }
    });

    await API.get(`/public/specialization`).then((resp) => {
      if (!resp.error && resp.data) {
        props.allSpecialization = resp.data;
      }
    });
    await API.get(`/public/blog-page/latest-post`).then((resp) => {
      if (!resp.error && resp.data) {
        props.posts = resp.data;
      }
    });

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
